
import { useMutation, useQueryClient } from 'react-query';
import { setHeaders } from '../../../utils/basic';
import axios from "axios";
import * as config from "../../../app.config";
import { USER_MESSAGE } from "../../../actions/User";
import { useDispatch } from "react-redux";

const useMutateUndoPlateName = () => {
    const queryClient = useQueryClient();
    const dispatch = useDispatch();

    const mutatePlateName = useMutation(async (batchId) => {
        const response = await axios.post(`${config.ENDPOINTS["datalake"]}/list_plates/mfg/clear_plate`, {
            batchId,
            headers: setHeaders()
        });
        return response?.data;
    },
        {
            onSuccess: (data) => {
                // This function is called when the mutation is successful.
                // `data` is the data returned from the mutation.
                console.log('Mutation was successful!', data);
                queryClient.invalidateQueries("QCPlatelist");
                dispatch({
                    type: USER_MESSAGE,
                    msgType: "success",
                    text: ` Plate Name cleared for Batch Name  and list refreshed`,
                    key: crypto.randomUUID()
                });

            },
            onError: (error) => {
                // This function is called when the mutation fails.
                // `error` is the error thrown from the mutation.
                console.log('Mutation failed!', error);
                queryClient.invalidateQueries("QCPlatelist");
                dispatch({
                    type: USER_MESSAGE,
                    msgType: "error",
                    text: ` Plate Name could not be cleared `,
                    key: crypto.randomUUID()
                });

            },
        }

    );

    return mutatePlateName;

};
export default useMutateUndoPlateName;